var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "el-form",
        { staticClass: "demo-ruleForm", attrs: { "label-width": "150px" } },
        [
          _c(
            "el-form-item",
            { attrs: { size: "small", label: "考号生成方式：" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: { prop: "date1" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small", placeholder: "自定义前缀" },
                      model: {
                        value: _vm.finalType,
                        callback: function ($$v) {
                          _vm.finalType = $$v
                        },
                        expression: "finalType",
                      },
                    },
                    _vm._l(_vm.taskList, function (item) {
                      return _c("el-option", {
                        key: item.type,
                        attrs: { label: item.name, value: item.type },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.finalType === 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: { prop: "date1" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          size: "small",
                          placeholder: "请输入前缀，例如KS",
                        },
                        model: {
                          value: _vm.prefix,
                          callback: function ($$v) {
                            _vm.prefix = $$v
                          },
                          expression: "prefix",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { size: "small", label: "考场个数：" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: { prop: "date1" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      size: "small",
                      placeholder: "请输入考场个数",
                    },
                    model: {
                      value: _vm.roomCount,
                      callback: function ($$v) {
                        _vm.roomCount = $$v
                      },
                      expression: "roomCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm._previewRoom()
                    },
                  },
                },
                [_vm._v("预览")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("p", { staticClass: "student-count" }, [
        _vm._v("参考学生总数 "),
        _c("span", [_vm._v(_vm._s(_vm.examStudentCount) + " ")]),
        _vm._v("，已分配座位 "),
        _c("span", [_vm._v(_vm._s(_vm.seatingCount))]),
      ]),
      _c(
        "ul",
        { staticClass: "room-wrapper" },
        [
          _vm._l(_vm.roomList, function (item, index) {
            return _c("li", { key: index, staticClass: "room-item" }, [
              _c("i", {
                staticClass: "delete",
                on: {
                  click: function ($event) {
                    return _vm._deleteRoom(index)
                  },
                },
              }),
              _c("div", { staticClass: "room-header" }, [
                _c("h6", [_vm._v(_vm._s(item.name) + " 考场")]),
                _c("img", {
                  attrs: { src: require("images/tool/edit.png"), width: "18" },
                  on: {
                    click: function ($event) {
                      return _vm._showEditDilaog(item)
                    },
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "num-wrapper" },
                [
                  _c("div", { staticClass: "num" }, [_vm._v("人数")]),
                  _c("el-slider", {
                    attrs: { "show-input": "", max: 100, "input-size": "mini" },
                    on: { change: _vm._countChange },
                    model: {
                      value: item.count,
                      callback: function ($$v) {
                        _vm.$set(item, "count", $$v)
                      },
                      expression: "item.count",
                    },
                  }),
                ],
                1
              ),
            ])
          }),
          _c("li", { staticClass: "room-item" }, [
            _c(
              "div",
              {
                staticClass: "add-room",
                on: {
                  click: function ($event) {
                    return _vm._addRoom()
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: require("images/tool/add.png"), width: "46" },
                }),
                _c("p", [_vm._v("添加考场")]),
              ]
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                type:
                  _vm.examStudentCount !== _vm.seatingCount
                    ? "info"
                    : "primary",
                loading: _vm.submitLoading,
              },
              on: {
                click: function ($event) {
                  return _vm._createExamTask()
                },
              },
            },
            [_vm._v("确认生成考务")]
          ),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "编辑考场",
            visible: _vm.editDialog,
            width: "500px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "30px 40px 0 30px" } },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "考场名称：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "2",
                          placeholder: "请输入阿拉伯数字",
                        },
                        model: {
                          value: _vm.roomName,
                          callback: function ($$v) {
                            _vm.roomName = $$v
                          },
                          expression: "roomName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.editDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm._saveRoomEdit()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }